class AccordionManager {
  constructor() {
    this.initializedSections = new Set();
    this.TRANSITION_DURATION = 300;
  }

  initSection(sectionId) {
    if (this.initializedSections.has(sectionId)) return;
    this.initializedSections.add(sectionId);

    const sectionElement = document.querySelector(
      `[data-accordion-section="${sectionId}"]`
    );
    if (!sectionElement) return;

    const buttons = sectionElement.parentElement.querySelectorAll(
      `[data-accordion-section="${sectionId}"] [data-accordion-toggle]`
    );
    const collapses = sectionElement.parentElement.querySelectorAll(
      `[data-accordion-section="${sectionId}"] .accordion-collapse`
    );

    // Initialize all accordions as closed
    collapses.forEach((collapse) => {
      collapse.style.height = "0";
    });

    buttons.forEach((button) => {
      button.addEventListener("click", (evt) =>
        this.handleAccordion(evt, sectionId)
      );
    });
  }

  handleAccordion(evt, sectionId) {
    const button = evt.currentTarget;
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    const targetId = button.getAttribute("aria-controls");
    const targetCollapse = document.getElementById(targetId);

    if (targetCollapse.classList.contains("collapsing")) return;

    // Get all accordions in this section
    const sectionElement = document.querySelector(
      `[data-accordion-section="${sectionId}"]`
    );
    const allButtons = sectionElement.parentElement.querySelectorAll(
      `[data-accordion-section="${sectionId}"] [data-accordion-toggle]`
    );
    const allCollapses = sectionElement.parentElement.querySelectorAll(
      `[data-accordion-section="${sectionId}"] .accordion-collapse`
    );

    // Close all other accordions in this section
    allButtons.forEach((btn) => {
      if (btn !== button) {
        const otherTargetId = btn.getAttribute("aria-controls");
        const otherCollapse = document.getElementById(otherTargetId);

        if (otherCollapse.classList.contains("show")) {
          btn.setAttribute("aria-expanded", "false");
          otherCollapse.classList.add("collapsing");
          otherCollapse.classList.remove("show");

          otherCollapse.style.height = `${otherCollapse.scrollHeight}px`;
          void otherCollapse.offsetHeight;
          otherCollapse.style.height = "0";

          setTimeout(() => {
            otherCollapse.classList.remove("collapsing");
            btn.closest(".accordion_item-basic").classList.remove("active");
          }, this.TRANSITION_DURATION);
        }
      }
    });

    // Toggle current accordion
    if (!isExpanded) {
      button.setAttribute("aria-expanded", "true");
      targetCollapse.classList.add("collapsing", "show");
      button.closest(".accordion_item-basic").classList.add("active");

      targetCollapse.style.height = "0";
      const contentHeight = targetCollapse.scrollHeight;
      targetCollapse.style.height = `${contentHeight}px`;

      setTimeout(() => {
        targetCollapse.classList.remove("collapsing");
        targetCollapse.style.height = "auto";
      }, this.TRANSITION_DURATION);
    } else {
      button.setAttribute("aria-expanded", "false");
      targetCollapse.classList.add("collapsing");
      targetCollapse.classList.remove("show");

      targetCollapse.style.height = `${targetCollapse.scrollHeight}px`;
      void targetCollapse.offsetHeight;
      targetCollapse.style.height = "0";

      setTimeout(() => {
        targetCollapse.classList.remove("collapsing");
        button.closest(".accordion_item-basic").classList.remove("active");
      }, this.TRANSITION_DURATION);
    }
  }
}

// Initialize the manager
const accordionManager = new AccordionManager();

// Expose initialization to liquid
window.initAccordionSection = (sectionId) => {
  accordionManager.initSection(sectionId);
};
